import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import CustomCursor from "../components/CustomCursor";
import CallbackModal from "../components/CallbackModal";
import { API, FALLBACK_CONTENT } from "../lib/api";

const PRIVACY_BODY = `
Big Bag Films Production уважает вашу конфиденциальность. Этот документ объясняет,
какие данные мы собираем при использовании сайта bigbagfilms.ru, как мы их храним
и для каких целей используем.

1. КАКИЕ ДАННЫЕ МЫ СОБИРАЕМ
Когда вы заполняете форму «Обсудить проект» или оставляете запрос на премьеру,
мы получаем номер телефона, имя (если вы его указали), email и сообщение.
Эти данные передаются добровольно и используются исключительно для связи с вами.

2. ЦЕЛИ ОБРАБОТКИ
— Связаться с вами по поводу проекта.
— Подготовить коммерческое предложение.
— Отправить материалы, о которых вы попросили.
Мы не передаём ваши данные третьим лицам, не используем их для рекламы
сторонних компаний и не продаём.

3. ХРАНЕНИЕ
Данные хранятся в защищённой базе с ограниченным доступом. Срок хранения —
не более 24 месяцев с момента последнего контакта, после чего удаляются.

4. COOKIES
Сайт использует только технические cookies, необходимые для работы (сессии,
сохранение состояния интерфейса). Аналитические cookies сторонних сервисов
не подключены.

5. ВАШИ ПРАВА
Вы можете запросить удаление ваших данных, направив запрос на bigbagfilms@gmail.com.
Мы удалим ваши данные в течение 14 рабочих дней с момента получения письма.

6. КОНТАКТЫ
Big Bag Films Production
Email: bigbagfilms@gmail.com
Сайт: bigbagfilms.ru

Данная политика может обновляться. Актуальная редакция всегда доступна по адресу
/privacy на нашем сайте.
`.trim();

export default function PrivacyPage() {
  const [site, setSite] = useState(FALLBACK_CONTENT.site);
  const [callbackOpen, setCallbackOpen] = useState(false);

  useEffect(() => {
    let active = true;
    axios.get(`${API}/content`).then((r) => {
      if (active) setSite({ ...FALLBACK_CONTENT.site, ...(r.data.site || {}) });
    }).catch(() => {});
    document.title = "Политика конфиденциальности · Big Bag Films";
    return () => { active = false; document.title = "Big Bag Films · Production"; };
  }, []);

  return (
    <main className="bbf-grain bg-[#050505] text-white min-h-screen">
      <CustomCursor />
      <Navigation site={site} onDiscussClick={() => setCallbackOpen(true)} />

      <article data-testid="privacy-page" className="pt-32 pb-20 px-5 sm:px-8 lg:px-12 max-w-3xl mx-auto">
        <Link to="/" className="font-mono-jb text-[11px] uppercase tracking-[0.22em] text-white/55 hover:text-white bbf-link">
          ← На главную
        </Link>

        <header className="mt-10 mb-12">
          <p className="overline">Юридическое</p>
          <h1 data-testid="privacy-title" className="font-display uppercase text-3xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-[0.95]">
            Политика конфиденциальности
          </h1>
          <p className="mt-5 font-mono-jb text-[11px] uppercase tracking-[0.22em] text-white/40">
            Редакция от {new Date().toLocaleDateString("ru-RU", { day: "numeric", month: "long", year: "numeric" })}
          </p>
        </header>

        <div className="bbf-article-body text-white/80 text-base sm:text-lg leading-relaxed whitespace-pre-line">
          {PRIVACY_BODY}
        </div>
      </article>

      <Footer site={site} />
      {callbackOpen && <CallbackModal onClose={() => setCallbackOpen(false)} />}
    </main>
  );
}
